import { CityCollectionDTO } from './CityCollectionDTO'
import { CityCollectionRaw } from './CityCollectionRaw'
import { CityDTOFactory } from './CityDTOFactory'

export class CityCollectionDTOFactory {
  static fromRaw(raw: CityCollectionRaw): CityCollectionDTO {
    return new CityCollectionDTO(raw.map(CityDTOFactory.fromRaw))
  }
}
